module.exports = __webpack_public_path__ + "img/engage-fig-3.a563e83c.png";